import { FC, ReactNode } from 'react';
import './header.scss';

/* -------------------------------------------------------------------------------- *\
|                               Header
\* -------------------------------------------------------------------------------- */
export const Header: FC<{ children?: ReactNode, title?: string }> = ({ title = '' }) =>
{
    return (
        <div className='header'>
            <div className='header__logo'>
                <a href="/">
                    <div className='header__logo__brand'>HPv2</div>
                </a>
                <div className='header__logo__text'>{title}</div>
            </div>
        </div>
    );
}
